export const MAX_LOADS_FOR_ORDER = 20
